export const CHANGE_BUBBLESCATTERCHART_OPTIONS = "CHANGE_BUBBLESCATTERCHART_OPTIONS"
